import React from 'react';
import PropTypes from 'prop-types';
import { useCountUp } from '../../hooks/useCountUp';

/**
 * Zahl, die beim Aendern hochzaehlt (Aura, Belegung, Match-Ring).
 * `format` bekommt den gerundeten Zwischenwert, z.B. (n) => `+${n}`.
 * Nicht-Zahlen (z.B. „∞“) werden unveraendert angezeigt.
 */
const AnimatedNumber = ({ value, from, duration, delay, format, className = '' }) => {
  const shown = useCountUp(value, { from, duration, delay });
  const text = typeof shown === 'number' ? Math.round(shown) : shown;
  return <span className={`tabular-nums ${className}`}>{format ? format(text) : text}</span>;
};

AnimatedNumber.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  from: PropTypes.number,
  duration: PropTypes.number,
  /** Millisekunden bis zum Start */
  delay: PropTypes.number,
  format: PropTypes.func,
  className: PropTypes.string,
};

export default AnimatedNumber;
